<!--
/**
 * 动态页脚容器组件 - AdaptiveIntercomFooter
 *
 * 功能描述：
 * 作为页面底部容器，包含动态内容插槽
 *
 * Slots:
 * @slot default - 底部主要内容区域
 *
 * 使用示例:
 * <AdaptiveIntercomFooter>
 *   您的底部内容
 * </AdaptiveIntercomFooter>
 */
-->
<template>
  <footer
    ref="el"
    v-bind="$attrs"
  >
    <slot />
  </footer>
</template>

<script setup>
const el = useTemplateRef('el')
</script>

<style lang="less">
</style>
